import DribbbleIcon from "../assets/images/dribbble.png";
import FacebookIcon from "../assets/images/facebook.png";
import InstagramIcon from "../assets/images/instagram.png";
import LinkedInIcon from "../assets/images/linkedIn.png";
import PinterestIcon from "../assets/images/pinterest.png";
import RedditIcon from "../assets/images/reddit.png";
import SnapchatIcon from "../assets/images/snapchat.png";
import TiktokIcon from "../assets/images/tiktok.png";
import TwitchIcon from "../assets/images/twitch.png";
import TwitterIcon from "../assets/images/twitter.png";
import WhatsappIcon from "../assets/images/whatsapp.png";
import YoutubeIcon from "../assets/images/youtube.png";

export const CheckEmailEnum = [
  {
    label: "Account not found.",
    value: 0,
  },
  {
    label: "Account found.",
    value: 1,
  },
];

export const RolesEnum = [
  {
    value: 1,
    label: "user",
  },
  {
    id: 2,
    label: "instructor",
  },
  {
    id: 3,
    label: "admin",
  },
];

export const CourseStatusesEnum = [
  {
    label: "Rejected",
    value: 0,
    color: "#ff472e",
  },
  {
    label: "Verified",
    value: 1,
    color: "#67bf59",
  },
  {
    label: "Pending",
    value: 2,
    color: "orange",
  },
];

export const CurrenciesEnum = [
  {
    label: "🇮🇷 IRR",
    description: "Iranian Rial",
    value: 2,
  },
  {
    label: "🇨🇦 CAD",
    description: "Canadian Dollar",
    value: 3,
  },
];

export const GendersEnum = [
  {
    label: "Male",
    value: 1,
  },
  {
    label: "Female",
    value: 2,
  },
  {
    label: "Prefer not to say",
    value: 3,
  },
];

export const OnboardingTypesEnum = [
  {
    label: "Single",
    value: 1,
  },
  {
    label: "Multiple",
    value: 2,
  },
];

export const LanguagesEnum = [
  {
    label: "English",
    value: "en",
  },
  {
    label: "Persian",
    value: "fa",
  },
];

export const SortCoursesEnum = [
  { label: "Most Popular", value: "1" },
  { label: "Newest First", value: "2" },
  { label: "Oldest First", value: "3" },
  { label: "Most Enrolled", value: "4" },
];

export const CourseLevelsEnum = [
  {
    label: "Beginner",
    value: 1,
    color: "success",
  },
  {
    label: "Intermediate",
    value: 2,
    color: "warning",
  },
  {
    label: "Advanced",
    value: 3,
    color: "danger",
  },
];

export const PromotionsEnum = [
  {
    label: "percentage",
    value: 2,
  },
];

export const TransactionsEnum = [
  {
    label: "Accepted",
    value: 1,
    color: "#67bf59",
  },
  {
    label: "Pending",
    value: 2,
    color: "orange",
  },
  {
    label: "Canceled",
    value: 3,
    color: "#ff472e",
  },
];

export const FontSizesEnum = [
  {
    label: "2",
    value: 2,
  },
  {
    label: "4",
    value: 4,
  },
  {
    label: "6",
    value: 6,
  },
  {
    label: "8",
    value: 8,
  },
  {
    label: "10",
    value: 10,
  },
  {
    label: "12",
    value: 12,
  },
  {
    label: "14",
    value: 14,
  },
  {
    label: "16",
    value: 16,
  },
  {
    label: "18",
    value: 18,
  },
  {
    label: "20",
    value: 20,
  },
  {
    label: "22",
    value: 22,
  },
  {
    label: "24",
    value: 24,
  },
  {
    label: "26",
    value: 26,
  },
  {
    label: "28",
    value: 28,
  },
  {
    label: "30",
    value: 30,
  },
  {
    label: "32",
    value: 32,
  },
  {
    label: "34",
    value: 34,
  },
  {
    label: "36",
    value: 36,
  },
  {
    label: "38",
    value: 38,
  },
  {
    label: "40",
    value: 40,
  },
  {
    label: "42",
    value: 42,
  },
  {
    label: "44",
    value: 44,
  },
  {
    label: "46",
    value: 46,
  },
  {
    label: "48",
    value: 48,
  },
  {
    label: "50",
    value: 50,
  },
  {
    label: "52",
    value: 52,
  },
  {
    label: "54",
    value: 54,
  },
  {
    label: "56",
    value: 56,
  },
  {
    label: "58",
    value: 58,
  },
  {
    label: "60",
    value: 60,
  },
  {
    label: "62",
    value: 62,
  },
  {
    label: "64",
    value: 64,
  },
  {
    label: "66",
    value: 66,
  },
  {
    label: "68",
    value: 68,
  },
  {
    label: "70",
    value: 70,
  },
  {
    label: "72",
    value: 72,
  },
  {
    label: "74",
    value: 74,
  },
  {
    label: "76",
    value: 76,
  },
  {
    label: "78",
    value: 78,
  },
  {
    label: "80",
    value: 80,
  },
  {
    label: "82",
    value: 82,
  },
  {
    label: "84",
    value: 84,
  },
  {
    label: "86",
    value: 86,
  },
  {
    label: "88",
    value: 88,
  },
  {
    label: "90",
    value: 90,
  },
  {
    label: "92",
    value: 92,
  },
  {
    label: "94",
    value: 94,
  },
  {
    label: "96",
    value: 96,
  },
  {
    label: "98",
    value: 98,
  },
  {
    label: "100",
    value: 100,
  },
];

export const InstructorSocialMediaEnum = [
  {
    label: "Instagram",
    value: "instagram",
    icon: InstagramIcon,
  },
  {
    label: "Tiktok",
    value: "tiktok",
    icon: TiktokIcon,
  },
  {
    label: "Youtube",
    value: "youtube",
    icon: YoutubeIcon,
  },
  {
    label: "Pinterest",
    value: "pinterest",
    icon: PinterestIcon,
  },
  {
    label: "Facebook",
    value: "facebook",
    icon: FacebookIcon,
  },
  {
    label: "Whatsapp",
    value: "whatsapp",
    icon: WhatsappIcon,
  },
  {
    label: "Twitter",
    value: "twitter",
    icon: TwitterIcon,
  },
  {
    label: "LinkedIn",
    value: "linkedin",
    icon: LinkedInIcon,
  },
  {
    label: "Snapchat",
    value: "snapchat",
    icon: SnapchatIcon,
  },
  {
    label: "Reddit",
    value: "reddit",
    icon: RedditIcon,
  },
  {
    label: "Twitch",
    value: "twitch",
    icon: TwitchIcon,
  },
  {
    label: "Dribbble",
    value: "dribbble",
    icon: DribbbleIcon,
  },
];

export const RefundTypesEnum = [
  {
    label: "Full",
    value: "FULL",
    color: "#67bf59",
  },
  {
    label: "Partial",
    value: "PARTIAL",
    color: "orange",
  },
];
